export function validateNhsNumber(nhsNumber) {
    // Ensure is well-formed
    // Stryker disable next 4 -- removing the ^ anchor is equivalent: strings with leading
    // non-digit chars produce NaN in the Luhn algorithm and are rejected anyway.
    // The early-return block is also equivalent: strings failing the regex also fail Luhn.
    const nhsNumberRegex = /^[0-9]{10}$/;
    if (!nhsNumberRegex.test(nhsNumber)) {
        return false;
    }
    // Checksum algorithm
    // see https://archive.datadictionary.nhs.uk/DD%20Release%20May%202024/attributes/nhs_number.html
    const providedChecksumDigit = parseInt(nhsNumber.charAt(9), 10);
    // perform weighted sum of digits based on position
    // eslint-disable-next-line @typescript-eslint/no-misused-spread
    const digitSum = [...nhsNumber.slice(0, 9)].reduce((acc, val, index) => acc + parseInt(val, 10) * (10 - index), 0);
    // calculate expected checksum digit,
    // performing a second modulo 11 to handle the case where the sum is 11
    const expectedChecksumDigit = (11 - (digitSum % 11)) % 11;
    // Compare the provided checksum digit with the expected checksum digit
    return providedChecksumDigit === expectedChecksumDigit;
}
//# sourceMappingURL=validator.js.map